export enum REASON_FOR_VISIT {
  STANDARD_CLAIM = 'STANDARD_CLAIM',
  BIG_WINNER = 'BIG_WINNER',
  REGULAR_TICKET = 'REGULAR_TICKET',
  PROBLEM_WITH_TICKET = 'PROBLEM_WITH_TICKET',
  UNKNOWN_WIN = 'UNKNOWN_WIN',
}
